var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"VendorSignupStripe",style:({ height: _vm.wraperHeight })},[_c('div',{ref:"container",attrs:{"id":"container"}}),(_vm.showError)?_c('div',[_vm._v("Something went wrong!")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }